// src/pages/CouponsPage.js
import React, { useEffect, useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';

const CouponsPage = () => {
  const { defaultTitle } = useTitle();
  const [coupons, setCoupons] = useState([]);
  const { user } = useAuthenticator((context) => [context.user]);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        if (!user) {
          return;
        }

        // ユーザーのセッションからJWTトークンを取得
        const idToken = user.signInUserSession.idToken.jwtToken;

        // APIリクエスト
        const response = await axios.get('https://your-api-endpoint/get-coupons', {
          headers: {
            Authorization: idToken,
          },
        });

        setCoupons(response.data.coupons);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCoupons();
  }, [user]);

  return React.createElement(
    'div',
    null,
    React.createElement(
      Helmet,
      null,
      React.createElement('title', null, `${defaultTitle} - クーポン`)
    ),
    React.createElement('h1', null, 'クーポン一覧'),
    coupons.length > 0
      ? React.createElement(
          'ul',
          null,
          coupons.map((coupon) =>
            React.createElement('li', { key: coupon.id }, coupon.description)
          )
        )
      : React.createElement('p', null, '配信中のクーポンはありません')
  );
};

export default CouponsPage;
